
import { A2AMessage } from '@/utils/a2a/types';
import { messageBus } from '@/utils/a2a/communication/messageBus';

export const useA2AMessaging = () => {
  const createDirectChannel = (agentIds: string[], context: string): string => {
    return messageBus.createBidirectionalChannel(agentIds, {
      context,
      intent: 'direct-collaboration',
      priority: 'normal'
    });
  };

  const getMessageBusStats = () => {
    return messageBus.getStats();
  };

  const subscribeToMessages = (
    agentId: string, 
    callback: (message: A2AMessage) => void
  ) => messageBus.subscribe({ 
    agentId, 
    callback, 
    messageTypes: ['*'] 
  });

  return {
    createDirectChannel,
    getMessageBusStats,
    subscribeToMessages
  };
};
